import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var ValuesPipe = (function () {
    function ValuesPipe() {
    }
    ValuesPipe.prototype.transform = function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).map(function (k) { return obj[k]; });
    };
    return ValuesPipe;
}());
export { ValuesPipe };
ValuesPipe.decorators = [
    { type: Pipe, args: [{ name: 'values' },] },
];
/** @nocollapse */
ValuesPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=values.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/values.js
// module id = 254
// module chunks = 4